import React, { useEffect, useState } from "react";
import "./App.css";
import { WebHeader } from "./files/components/WebHeader";
import Theme from "./files/jsonObjects/theme.json";
import { WebPage } from "./files/components/WebPage";
import { NavMenu } from "./files/components/NavMenu";
import { LogInPage } from "./files/Pages/LogInPage";
import { useLocation } from "react-router-dom";
import SettingsMenu from "./files/components/SettingsMenu";
import { NewPassword } from "./files/components/NewPassword";
import useToggleScroll from "./files/components/useToggleScroll";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { notify, Toast } from "./files/components/Toast/Toast";


function fillTheme() {
  document.documentElement.style.setProperty(
    "--background-color",
    Theme.colors.background,
  );
  document.documentElement.style.setProperty(
    "--foreground-color",
    Theme.colors.foreground,
  );
  document.documentElement.style.setProperty(
    "--accent-color",
    Theme.colors.accent,
  );
}

function App() {
  function getCode() {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    return code;
  }

  const [code, setCode] = useState(getCode);
  const [activePage, setActivePage] = useState("Dashboard");
  const [activeCount, setActiveCount] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUserId = localStorage.getItem("UserID");
    if (storedUserId) {
      setUser({ id: storedUserId }); // Assuming you want to store an object with the ID
    }

    if (Date.now() - parseInt(localStorage.getItem("expire")) > 36000000) {
      localStorage.clear();
      setUser(null);
    } else {
      localStorage.setItem("expire", "" + Date.now());
    }
  }, []);

  useEffect(() => {
  
    const handleOnline = () => {
      notify("success", "Uppkopplad");
    };

    const handleOffline = () => {
      notify("warning", "Tappade uppkoppling!");
    };

    if (!window.navigator.onLine) {
      handleOffline();
    }
  
  
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
  
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);
  


  

  useToggleScroll([showMenu, showProfile]);

  function yani(id) {
    setActivePage("Inventeringar");
    setActiveCount(id);
  }

  fillTheme();

  if (code) return <NewPassword code={code} close={() => setCode(null)} />;

  if (user != null) {
    return (
      <div className="App">
        {showMenu && (
          <NavMenu
            setShowMenu={setShowMenu}
            setActivePage={setActivePage}
            setUser={setUser}
          />
        )}
        {showProfile && <SettingsMenu setShow={setShowProfile} />}
        <div>
          <WebHeader
            Title={activePage}
            setShowMenu={setShowMenu}
            setShowProfile={setShowProfile}
          />
          <WebPage
            activePage={activePage}
            openCounts={yani}
            activeCount={activeCount}
            setActiveCount={setActiveCount}
          ></WebPage>
        </div>
        <Toast/>
      </div>
    );
  } else {
    return <LogInPage setUser={setUser} />;
  }
}

export default App;
